import * as types from '../constants'
import callAPI from '../callAPI/callAPI'

export const getAllOrder = (orders) => {
    return {
        type: types.GET_ALL_ORDER,
        payload: orders
    }
}

export const fetchAPIAllOrder = () => {
    return dispatch => {
        return callAPI('orders', 'GET', null).then(res => {
            dispatch(getAllOrder(res.data))
        })
    }
}

export const getOrderDetail = (order) => {
    return {
        type: types.GET_ORDER_DETAIL,
        payload: order
    }
}

export const fetchAPIOrderDetail = (id) => {
    return dispatch => {
        return callAPI(`orders/${id}`, 'GET', null).then(res => {
            dispatch(getOrderDetail(res.data))
        })
    }
}

export const changeStatusOrder = (order) => {
    return {
        type: types.CHANGE_STATUS_ORDER,
        payload: order
    }
}

export const fetchAPIChangeStatusOrder = (order) => {
    return dispatch => {
        return callAPI(`orders/${order.id}`, 'PUT', order).then(res => {
            dispatch(changeStatusOrder(res.data))
            dispatch(fetchAPIAllOrder())
        })
    }
}